import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "@quark/design/dist/index.css";
import "@quark/questions/dist/index.css";
import "katex/dist/katex.css";
import App from "./App";
import { HashRouter } from "react-router-dom";
import * as Sentry from "@sentry/react";
import dayjs from "dayjs";
import isToday from "dayjs/plugin/isToday";
import LoginWrapper from "./component/login-wrapper";
import AssistantWrapper from "./component/assitant-wrapper";

dayjs.extend(isToday);

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: "https://1827e68d546147ff8e1d370ef0dc2acb@o391314.ingest.sentry.io/4504299497652224",
    integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,
    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,
  });
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const Entry = () => {
  return (
    <HashRouter>
      <LoginWrapper>
        <AssistantWrapper>
          <App />
        </AssistantWrapper>
      </LoginWrapper>
    </HashRouter>
  );
};

if (import.meta.env.DEV) {
  root.render(<Entry />);
} else {
  root.render(
    <React.StrictMode>
      <Entry />
    </React.StrictMode>
  );
}
